/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgHandRight = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M2 16.038C2 19.325 4.69 22 7.998 22H10c1.654 0 3-1.338 3-2.982 0-.348-.06-.683-.171-.994H14c1.654 0 3-1.338 3-2.982 0-.348-.06-.683-.171-.994H19c1.654 0 3-1.338 3-2.982 0-1.644-1.346-2.982-3-2.982h-4.586l.793-.788a3.093 3.093 0 0 0 0-4.387C14.618 2.322 13.834 2 13 2s-1.618.322-2.207.909l-1.5 1.49-3.146 2.676A11.765 11.765 0 0 0 2 16.038zm9-3.978v1.988h3c.552 0 1 .445 1 .994s-.448.994-1 .994H9v1.988h1c.552 0 1 .445 1 .994a.997.997 0 0 1-1 .994H7.998C5.794 20.012 4 18.23 4 16.038a9.783 9.783 0 0 1 3.448-7.453l3.202-2.728 1.557-1.543c.212-.21.493-.326.793-.326a1.116 1.116 0 0 1 .793 1.902l-2.5 2.485a.985.985 0 0 0-.217 1.084 1 1 0 0 0 .924.613h7c.552 0 1 .445 1 .994s-.448.994-1 .994z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgHandRight as HandRight };
